// utils/case.js

/**
 * Capitalize only the first letter of the sentence
 * Example: "hello world" => "Hello world"
 */
export const sentenceCase = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Capitalize first letter of every word (Title Case)
 * Example: "sign in" => "Sign In"
 */
export const titleCase = (str) => {
  if (!str) return "";
  return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1));
};